// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"320":"0798b244","398":"3bc04c1f","551":"4e212507","828":"a58bd757","905":"f82b7166"}[chunkId] + ".chunk.js");